import DOMPurify from 'dompurify';

/**
 * 振替結果インポート確認画面のセル描画用。
 * セルHTMLはバックエンド（import/zengin.php）のエラー文言と billImportCtrl の組み立てで
 * 構成され、登場する要素は div / br とその class / style 属性のみのため、それだけを明示的に許可する。
 */
export function sanitize(content: string): string {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: ['div', 'br'],
    ALLOWED_ATTR: ['class', 'style'],
  });
}
